module.exports = __webpack_public_path__ + "static/media/bell.3117bf24.svg";